import { Link, List, ListItem, ListSubheader, Typography } from "@mui/material";
import {
  baseFormats,
  baseOptionsUrl,
  extraWFSFormats,
  wfsOptionsUrl,
} from "config/allFormats";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Layer } from "types/types";
import { LayerSetAccordion } from "./LayerSetAccordion";

interface Props {
  selectedLayer: Layer;
}

export default function LayerSetAllFormatsAccordion(props: Props) {
  const { selectedLayer } = props;
  const { t } = useTranslation();
  const baseOptions = baseFormats;
  const wfsOptions = extraWFSFormats;
  const url = insertLayer(baseOptionsUrl, selectedLayer.geoserverLayer);
  const wfsUrl = insertLayer(wfsOptionsUrl, selectedLayer.geoserverLayer);

  function insertLayer(url: string, layer: string) {
    return url.replace("insertLayerHere", layer);
  }

  return (
    <LayerSetAccordion title={t("label.wmsWfsLink")}>
      <List dense disablePadding>
        <ListSubheader>
          <Typography variant="subtitle1">{t("label.wms")}</Typography>
        </ListSubheader>

        {baseOptions.map((option, i) => (
          <ListItem key={`${option.value}-${i}`}>
            <Link href={`${url}${option.value}`} target="_blank">
              {option.label}
            </Link>
          </ListItem>
        ))}
        {selectedLayer.type === "WFS" && (
          <Fragment>
            <ListSubheader sx={{ marginTop: "8px" }}>
              <Typography variant="subtitle1">{t("label.wfs")}</Typography>
            </ListSubheader>
            {wfsOptions.map((option, i) => (
              <ListItem key={`${option.value}-${i}`}>
                <Link href={`${wfsUrl}${option.value}`} target="_blank">
                  {option.label}
                </Link>
              </ListItem>
            ))}
          </Fragment>
        )}
      </List>
    </LayerSetAccordion>
  );
}
